var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConvoComboIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke border",
    d: "M21 12a9 9 0 0 1-9 9c-2.5 0-3.162-.704-4-1-.838-.296-5 1-5 1s1.952-2.722 1.5-4C3 14.5 3 13.052 3 12a9 9 0 0 1 18 0Z",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke cross",
    d: "M8.5 8.5 12 12m0 0 3.5 3.5M12 12l-3.5 3.5M12 12l3.5-3.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "stroke snoozing",
    d: "M7.5 12h3l-3 4h3m2-8h4l-4 6h4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "dots",
    d: "M7.94 13.5c.967 0 1.477-.507 1.477-1.5 0-.974-.51-1.5-1.477-1.5-.875 0-1.44.526-1.44 1.5s.547 1.5 1.44 1.5ZM11.982 13.5c.966 0 1.477-.507 1.477-1.5 0-.974-.51-1.5-1.477-1.5-.875 0-1.44.526-1.44 1.5s.546 1.5 1.44 1.5ZM15.94 13.5c.967 0 1.477-.507 1.477-1.5 0-.974-.51-1.5-1.477-1.5-.875 0-1.44.526-1.44 1.5s.547 1.5 1.44 1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvoComboIcon);
export default __webpack_public_path__ + "static/media/convo-combo-icon.0d837995f474bd1c8c22d8f3753a5f45.svg";
export { ForwardRef as ReactComponent };